import { PlusCircleIcon } from "lucide-react";
import { TriggerButton } from "./TriggerButton";
import { forwardRef } from "react";

export interface CreateTriggerButtonProps {
  text?: string;
  icon?: React.ReactNode;
  disabled?: boolean;
  onClick?: () => void;
}

export const CreateTriggerButton = forwardRef<
  HTMLButtonElement,
  CreateTriggerButtonProps
>(({ onClick, disabled = false }, ref) => {
  return (
    <TriggerButton
      ref={ref}
      text="Create"
      icon={<PlusCircleIcon />}
      onClick={onClick}
      disabled={disabled}
    />
  );
});
